"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendRequest = void 0;
var promise_1 = require("./promise");
var url_1 = require("./url");
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(message, _a) {
        var status = _a.status, text = _a.text, url = _a.url, data = _a.data;
        var _this = _super.call(this, message) || this;
        _this.name = 'NetworkError';
        _this.status = status;
        _this.text = text;
        _this.data = data;
        _this.url = url;
        return _this;
    }
    return NetworkError;
}(Error));
// if you change anything here, please also update copy in wix-music-widget src/scripts/utils/send-request.js
function sendRequest(options) {
    options = __assign({ method: 'GET', type: 'json', withCredentials: false }, options);
    if (!options.url) {
        throw new TypeError('url is not specified');
    }
    if (options.type === 'json') {
        options = withJsonDefaults(options);
    }
    var method = options.method, url = options.url, data = options.data, params = options.params, headers = options.headers;
    var parametrizedUrl = createParametrizeUrl(url, params);
    var requestPromise = new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.addEventListener('load', function () {
            var response = {
                status: request.status,
                text: request.responseText,
                data: null,
            };
            try {
                response.data = parseResponseBody(request);
            }
            catch (reason) {
                reject(reason);
            }
            if (request.status < 200 || request.status > 299) {
                reject(new NetworkError("NetworkError: ".concat(request.status, " on ").concat(url), __assign(__assign({}, response), { url: url })));
                return;
            }
            resolve(response);
        });
        function onError(status, text) {
            return function () {
                reject(new NetworkError("NetworkError: ".concat(text, " event on ").concat(url), { status: status, text: text, url: url, data: text }));
            };
        }
        request.addEventListener('error', onError(-100, 'error'));
        request.addEventListener('abort', onError(-200, 'aborted'));
        request.open(method, parametrizedUrl, true);
        request.withCredentials = options.withCredentials;
        Object.keys(headers).forEach(function (header) {
            request.setRequestHeader(header, headers[header]);
        });
        request.send(data);
    });
    if (options.timeout) {
        return (0, promise_1.addTimeout)(requestPromise, {
            time: options.timeout,
            reason: 'RequestTimeout',
        });
    }
    return requestPromise;
}
exports.sendRequest = sendRequest;
function withJsonDefaults(options) {
    function getHeaders() {
        var headers = {
            Accept: 'application/json',
        };
        if (options.method === 'POST') {
            headers['Content-Type'] = 'application/json; charset=utf-8';
        }
        return __assign(__assign({}, headers), options.headers);
    }
    function getData() {
        var data = options.data;
        return data && typeof data === 'object' ? JSON.stringify(data) : data;
    }
    return __assign(__assign({}, options), { headers: getHeaders(), data: getData() });
}
function createParametrizeUrl(url, params) {
    if (!params || !Object.keys(params).length) {
        return url;
    }
    if (url.indexOf('?') !== -1) {
        throw new TypeError('Adding param to urls with params is not supported');
    }
    var stringifiedParams = (0, url_1.createParam)(params);
    return "".concat(url, "?").concat(stringifiedParams);
}
function parseResponseBody(request) {
    var contentType = request.getResponseHeader('Content-Type');
    if (contentType && (contentType.includes('application/javascript') || contentType.includes('application/json'))) {
        try {
            return JSON.parse(request.responseText);
        }
        catch (ex) {
            throw new Error('Cannot parse response body');
        }
    }
    return request.responseText;
}
//# sourceMappingURL=send-request.js.map